import React, {FC} from "react";
import TableWrapper from "../../../components/table/TableWrapper";
import {routes} from "../../../app/routes";
import {Button} from "primereact/button";
import {useNavigate} from "react-router-dom";
import {useFindIndustriesQuery} from "../../../api/eventsStoreApi";
import TextInput from "../../../components/form/TextInput";
import {selectSettingState, setSettingData} from "../../../slices/settingsSlice";
import {useAppSelector} from "../../../app/hooks";
import industryActionTemplate from "./Actions";
import {PrimeIcons} from "primereact/api";

const Industries: FC<{}> = ({}) => {
    const navigate = useNavigate();
    const {industryFilter} = useAppSelector(selectSettingState);
    const {isLoading, data} = useFindIndustriesQuery({
        page: 0,
        size: 10000
    });

    const columns = [
        {field: "name", header: "Name", sortable: true},
        {
            field: "",
            header: "Action",
            body: industryActionTemplate,
        },
    ];

    return (
        <>
            <TextInput
                id="industryFilter"
                name="industryFilter"
                label=""
                value={industryFilter}
                setProperty={setSettingData}
                searchIcon
                placeholder="Search"
            />
            <TableWrapper
                header="Industries"
                isLoading={isLoading}
                data={data?.content}
                columns={columns}
                globalFilter={industryFilter}
                addButton={<Button onClick={() => navigate(routes.ADD)} label="Add" icon={PrimeIcons.PLUS}/>}
                stateKey="industries-list"
            />
        </>
    );
};

export default Industries;
